import { useI18n } from '@ecom/i18n';
import { Table, TableBody, TableCell, TableHead, TableHeaderCell, TableRow } from '@ecom/ui-kit';
import { type ReactElement } from 'react';

import type { CustomerSummary } from '../types';

import { formatCatalogPrice } from '@/features/products/format-price';

function formatDate(iso: string): string {
  return new Intl.DateTimeFormat('fr-TN', { dateStyle: 'medium' }).format(new Date(iso));
}

/**
 * "Liste clients" — nom, téléphone (pas d'email : `MerchantOrder` n'en
 * porte pas, jamais inventé ici), commandes, dernière activité, total
 * dépensé — chaque colonne un vrai agrégat, voir `features/clients/api.ts`.
 */
export function CustomerTable({
  customers,
  onSelect,
}: {
  customers: readonly CustomerSummary[];
  onSelect: (customer: CustomerSummary) => void;
}): ReactElement {
  const { t } = useI18n();
  return (
    <Table caption={t('merchant.nav.customers')}>
      <TableHead>
        <TableRow>
          <TableHeaderCell>{t('merchant.clients.table.colClient')}</TableHeaderCell>
          <TableHeaderCell>{t('merchant.store.form.phoneLabel')}</TableHeaderCell>
          <TableHeaderCell align="end">{t('merchant.orders.title')}</TableHeaderCell>
          <TableHeaderCell>{t('merchant.clients.table.colLastActivity')}</TableHeaderCell>
          <TableHeaderCell align="end">{t('merchant.clients.table.colTotalSpent')}</TableHeaderCell>
          <TableHeaderCell> </TableHeaderCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {customers.map((customer) => (
          <TableRow key={customer.phone}>
            <TableCell>
              <span className="text-sm font-medium text-ink">{customer.name}</span>
            </TableCell>
            <TableCell>
              <span className="font-mono text-xs text-inkSoft">{customer.phone}</span>
            </TableCell>
            <TableCell align="end">
              <span className="text-sm text-ink">{customer.orderCount}</span>
            </TableCell>
            <TableCell>
              <span className="text-sm text-inkFaint">{formatDate(customer.lastActivityAt)}</span>
            </TableCell>
            <TableCell align="end">
              <span className="font-mono text-sm font-semibold text-ink">
                {formatCatalogPrice(customer.totalSpent)}
              </span>
            </TableCell>
            <TableCell align="end">
              <button
                type="button"
                onClick={() => {
                  onSelect(customer);
                }}
                className="text-xs font-medium text-accent hover:underline"
              >
                {t('merchant.clients.viewDetail')}
              </button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
